export const TAG_COLORS = Object.freeze({
  GREEN: "green",
  ORANGE: "orange",
  RED: "red",
});
